import React, {useCallback, useState, useEffect} from 'react'
import { Link } from "gatsby"
import { detectMobile, isSSR } from 'utils'
import {useDropzone} from 'react-dropzone'
import styled from 'styled-components'
import { colors } from "config"
import Attach from "./icons/attach"
import Pdf from "./icons/pdf"
import Doc from "./icons/doc"
import ImageSVG from "./icons/image"
import Cloud from "./icons/cloud"
import spot from "content/images/spot.svg"
import Check from './icons/check'
import Animation from "./animation"
import {CGU, language} from "config"


const StyledDropzone = styled.div`
  background: #152534;
  background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='11' ry='11' stroke='rgb(132, 162, 183)' stroke-width='3' stroke-dasharray='6%2c 14' stroke-dashoffset='12' stroke-linecap='square'/%3e%3c/svg%3e");
  box-sizing: border-box;
  border-radius: 0.5882rem;
  padding: 1.3rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  cursor: pointer;
  transition: transform 0.2s;
  &:hover {
    transform: scale(1.02);
    transition: transform 0.2s;
    .logos {
      .doc {
        transform: translate(-0.5882rem, -0.2941rem);
      }
      .image {
        transform: translate(0.5882rem, 0.2941rem);
      }
      .attachment {
        transform: translate(0.5882rem, -0.5882rem);
      }
      .pdf {
        transform: translateX(0.5882rem);
      }
    }
  }
  .logos {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    .doc, .pdf {
      margin-top: 1rem;
      transition: all 0.2s linear;
    }
    .image {
      margin: 0 1rem;
      transition: all 0.2s linear;
    }
    .attachment {
      margin-right: 1rem;
      margin-top: 3rem;
      transition: all 0.2s linear;
    }
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    background: #FBFBFF;
    background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='11' ry='11' stroke='rgb(188, 188, 207)' stroke-width='3' stroke-dasharray='6%2c 14' stroke-dashoffset='12' stroke-linecap='square'/%3e%3c/svg%3e");
  }
`
const StyledCard = styled.div`
  background: #152534;
  border-radius: 0;
  height: ${props => props.animation ? '100%' : '17rem'};
  padding: 0.71rem;
  padding: 1.41168rem;
  overflow: scroll;
  .text {
    color: #FFFFFF;
  }
  width: 100vw;
  margin-left: ${props => props.animation ? 'unset' : '-1rem'};
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    background: #FBFBFF;
    border-radius: 0.5882rem;
    width: 100%;
    height: 14.46rem;
    padding: 0.71rem;
    margin-left: 0;
    overflow: unset;
    .text {
      color: #3E4655;
    }
  }
`

const StyledDivider = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  margin: 0.94112rem 0;
  span {
    width: 85px;
    height: 0;
    border: 1px solid #C6D7EA;
  }
  div {
    margin: 0 0.5882rem
  }
`

const StyledButton = styled(Link)`
  background: rgba(21, 37, 52, 0.56);
  border: 1px solid #2D4359;
  box-sizing: border-box;
  border-radius: 0.5882rem;
  color: white;
  font-size: 0.94112rem;
  line-height: 1.1764rem;
  text-align: center;
  width: 100%;
  padding: 1.1764rem;
  margin: 0 auto;
  cursor: pointer;
  transition: all 0.1s linear;
  margin-bottom: 1rem;
  &:hover {
    filter: grayscale(50%) contrast(1) brightness(90%);
    transform: translate3d(0px, -0.1rem, 0px);
    box-shadow: 0 0 2.5rem rgba(0, 0, 0, 0.32);
  }
  svg {
    width: 1rem;
    height: 1rem;
    margin-right: 1rem;
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    width: 100%;
    margin: 0;
    margin-top: 1rem;
    background: rgba(0, 0, 0, 0.53);
    border: 1px solid rgba(208, 208, 208, 0.29);
  }
`

const StyledButtonPrimary = styled(StyledButton)`
  background: #E0690F!important;
  color: white;
  display: flex;
  justify-content: center;
  margin: 0;
  width: 100%;
  margin: 0 auto;
  margin-bottom: 1rem;
  margin-top: 1rem;
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    width: 100%;
    margin: 0;
    margin-top: 1rem;
  }
  &:hover {
    filter: unset;
    transform: unset;
    box-shadow: unset;
    opacity: 0.8;
  }
`

const StyledCardWrapper = styled.div`
  background: #152534;
  width: 100vw;
  margin-left: -1rem;
  height: calc(100vh - 11.5rem);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  a {
    width: 90%;
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    background: unset;
    margin-left: 0;
    height: unset;
    display: block;
    width: unset;
    a {
      width: 100%;
    }
  }
  .error.text {
    margin-top: 17px;
  }
`

const StyledCardText = styled(StyledCard)`
  padding: 0;
  .header {
    padding: 1rem 1.29404rem;
    .text {
      color: #FFFFFF;
      font-style: normal;
      font-weight: 600;
      font-size: 0.94112rem;
      line-height: 1.1764rem;
    }
  }
  .body {
    padding: 0.5882rem 1.29404rem;
    padding-top: 0;
    background: #152534;
    border: 1px solid #192B3D;
    color: #9DB9D6;
    height: 23rem;
    overflow: auto;
    padding-bottom: 0;
    font-style: italic;
    font-weight: normal;
    font-size: 0.71rem;
    line-height: 1.35286rem;
    margin-right: 0.3rem;
    &::-webkit-scrollbar {
      width: 0.4292rem;
      background: #E4E4EB;
      border-radius: 5.882rem;
    }
    
    /* Track */
    &::-webkit-scrollbar-track {
      background: #E4E4EB;
      border-radius: 5.882rem;
    }
    
    /* Handle */
    &::-webkit-scrollbar-thumb {
      //background: ${({ theme }) => theme.colors.primary};
      background: #E0690F;
      border-radius: 5.882rem;
    }
    .cgu-header {
      font-style: normal;
      font-weight: 600;
      font-size: 0.8112rem;
      line-height: 1.14rem;
    }
    a {
      text-decoration: underline;
      color: rgb(78 78 175)!important;
      width: unset;
    }
    h4 {
      margin-top: unset;
    }
  }
  margin-left: 0;
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    .header {
      padding: 1.29404rem;
      .text {
        color: #3E4655;
        font-weight: 600;
        font-size: 0.8rem;
        line-height: 0.94112rem;
        text-transform: uppercase;
      }
    }
    .body {
      border: none;
      border-top: 1px solid #E4E4EC;
      background: #FBFBFF;
      color: #636E81;
      height: 9.5rem;
      padding-top: 0.5882rem;
      h4 {
        margin-top: unset;
      }
      a {
        color: #636E81!important;
      }
    }
  }
`


const base64ToFile = (dataurl, filename) => {
  let arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
      
  while(n--){
      u8arr[n] = bstr.charCodeAt(n);
  }
  
  return new File([u8arr], filename, {type:mime});
};

const Dropzone = (props) => {
  const [profileFile, setProfileFile] = useState("");
  const [retry, setRetry] = useState(false);


  const onDrop = useCallback((acceptedFiles) => {
    acceptedFiles.forEach((file) => {
      const reader = new FileReader()
      if (file.type.match(/image.*/)) {
        reader.onload = (e) => {
          const img = new Image();
          img.src = e.target.result;
          img.onload = () => {
            let width = img.width;
            let height = img.height;
            const MAX_WIDTH = 1190;
            const MAX_HEIGHT = 1684;
            
            if (width > MAX_WIDTH || height > MAX_HEIGHT) {
              if (width > height) {
                if (width > MAX_WIDTH) {
                  height *= MAX_WIDTH / width;
                  width = MAX_WIDTH;
                }
              } else {
                if (height > MAX_HEIGHT) {
                  width *= MAX_HEIGHT / height;
                  height = MAX_HEIGHT;
                }
              }
              
              const canvas = document.createElement('canvas');
              canvas.width = width;
              canvas.height = height;
              const ctx = canvas.getContext('2d');
              ctx.drawImage(img, 0, 0, width, height);
              const dataUrl = canvas.toDataURL('image/png');
              const resizedFile = base64ToFile(dataUrl, file.name);
              // Use the resized file
              setProfileFile(resizedFile);
            } else {
              // Use the original file if no resizing is needed
              setProfileFile(file);
            }
          };
        };
        reader.readAsDataURL(file);
      } else {

        reader.readAsArrayBuffer(file)
        setProfileFile(file)
      }
      if(!CGU.consent) {
        props.addProfile({file: file, consent: true, redirect: true, details: false, token: urlSearchParams, lang: props.lang})
        setRetry(false)
      }
    })
    
  }, [])

  const {getRootProps, getInputProps} = useDropzone({onDrop})
  const postProfile = (consentController) => {
    props.addProfile({file: profileFile, consent: consentController, redirect: true, details: false, token: urlSearchParams, lang: props.lang})
    setRetry(false)
  }

  const deleteFile = () => {
    setProfileFile(null)
    setRetry(true)
  }

    // const urlSearchParams =  new URLSearchParams(!isSSR && window.location.search).get('params') || new URLSearchParams(!isSSR && window.location.search).get('token')
const urlSearchParams = "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"

  return (
    <>
      { profileFile && detectMobile(window.innerWidth) ?
        (
          '' 
        )
        :
        (
          <>
            <h1 className="section-title">{props.content.title}</h1>
            <div className="section-subtitle">{props.content.subtitle}<br/><br/>{props.content.subtitlePrefix}</div>
          </>
        )
      }
      {
        profileFile ? 
        (
          props.profile && props.profile.r ?
          (
            <StyledCardWrapper>
              <StyledCard animation>
                <Animation />
              </StyledCard>
            </StyledCardWrapper>
          )
          :
          (
            <>
              {props.profile && props.profile.f && !retry ?
              (
                <StyledCardWrapper>
                  <div className="text error text-center">
                    {language.dropzone_error}
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column'}}>
                    <StyledButtonPrimary to="#" onClick={() => postProfile(true)}>
                      {language.retry}
                    </StyledButtonPrimary>
                    <StyledButton to="#" onClick={() => deleteFile()}>
                      {language.cancel}
                    </StyledButton>
                  </div>
                </StyledCardWrapper>
              )
              :
              (
                <StyledCardWrapper>
                  <StyledCardText>
                    <div className="header">
                      <div className="text">
                        {language.consent_header}
                      </div>
                    </div>
                    <div className="body">
                      <div className="cgu-header">
                        {language.consent_title}
                      </div>
                      <div dangerouslySetInnerHTML={{ __html: CGU.content }} />
                    </div>
                  </StyledCardText>
                  <div style={{ display: 'flex', flexDirection: 'column'}}>
                    <StyledButtonPrimary to="#" onClick={() => postProfile(true)}>
                      <Check className="icon" color="#fff" /> {language.accept}
                    </StyledButtonPrimary>
                    <StyledButton to="#" onClick={() => deleteFile()}>
                      {language.cancel}
                    </StyledButton>
                  </div>
                </StyledCardWrapper>
              )
              } 
            </>
          )
        )
        :
        (
          <>
            <StyledCard>
              <StyledDropzone {...getRootProps()}>
                <input {...getInputProps()} />
                <div className="logos">
                  <div className="doc">
                    <Doc  color={!isSSR && detectMobile(window.innerWidth) ? colors.darkTheme.text : '#E0690F'} />
                  </div>
                  <div className="image">
                    <ImageSVG  color={!isSSR && detectMobile(window.innerWidth) ? colors.darkTheme.text : '#E0690F'} />
                  </div>
                  <div className="attachment">
                    <Attach  color={!isSSR && detectMobile(window.innerWidth) ? colors.darkTheme.text : '#E0690F'} />
                  </div>
                  <div className="pdf">
                    <Pdf  color={!isSSR && detectMobile(window.innerWidth) ? colors.darkTheme.text : '#E0690F'} />
                  </div>
                </div>
               {/*  <div className="cloud-wrapper">
                  <Cloud color={!isSSR && detectMobile(window.innerWidth) ? colors.darkTheme.text : colors.darkTheme.primary} />
                </div> */}
                <div className="cloud-wrapper">
                  <StyledButtonPrimary 
                    style={{
                      marginBottom: '0.5rem',
                      padding: '0.8rem 1rem',
                      fontSize: '0.8rem',

                    }}
                  >
                      <Cloud color="white" /> {language.dropzone_button_text}
                  </StyledButtonPrimary>
                </div>
                <div className="text">
                  {language.dropzone_text}
                </div>
              </StyledDropzone>
            </StyledCard>
            <StyledDivider>
              <span></span>
              <div>{language.or}</div>
              <span></span>
            </StyledDivider>
            <StyledButton style={{marginTop: '0'}} to={`jobs`}>
              {language.redirection_button}
            </StyledButton>
            {/* <StyledButton to={`/without-resume`}>
              Candidater sans CV
            </StyledButton> */}
          </>
        )
      }
    </>
  );
}

export default Dropzone